const state = {
  preheatIng: "Pré-aquecimento",
  purchaseIng: "Acelerando",
  process: "Assistência",
  over: "Terminado",
  finish: "Concluído",
  noData: "Sem dados",
};

const subheader = {
  pricePromise: "Preço Garantido, Nunca Quebre",
  vipPrice: "Reembolso VIP, Desconto no Preço",
  protection: "Preço Exclusivo Garantido em Moeda Fiat",
  pricePromiseVal: "[*]Preço Garantido no Dia, Nunca Quebre",
  rewards: "[*]% de Renda, Preço Garantido Garantido",
  vipDis: "Desconto VIP, Pegue e Ganhe",
  zlz: "Assistência",
};

const purchaseCondition = {
  q: "e ",
  h: " ou ",
  cztj: "Garantir a quantidade de recarga",
  wqyh: "Somente para usuários que não participaram de eventos anteriores relevantes",
  vipdj: "Somente para usuários VIP[*] e acima do nível VIP",
  condition: "Condições de compra urgente",
  conditionNew: "Condições de reforço",
  nameverify1: "Certificação KYC completa na China continental",
  nameverify2: "Certificação KYC completa fora da China continental",
  nameverify3: "Certificação KYC BiKing completa",
  login: "Faça login",
  maxBuyin: "Compra máxima",
  verify: "Ir para verificação KYC",
  affirm: "Certifique-se de que as participações são maiores que [*]",
  myPosition: "Minhas participações",
  AmountOfAscension: "Cota de compra",
  AmountOfAscensionNew: "Cota de assistência",
  AmountOfAscensionText:
    "Quanto maior a [*] média diária de participações nos 7 dias anteriores à primeira rodada, maior sua cota de corrida",
  AmountOfAscensionTime:
    "Minha média diária de participações dos últimos 7 dias[*]",
  discount: "Desconto pushing",
  vip_discount: "Desconto de assistência",
  discountText: "Quanto maior o nível VIP, menor o preço de compra",
  upgrade: "Ir para upgrade",
  vipUpgrade: "Meu VIP",
  zled: " Cota de assistência",
  wdzl: "Minha assistência",
  zlxm: "Assist Project",
  mlzl: "Cada rodada de assistência",
  zlmx: "Detalhes da assistência",
  ccff: "Liberação inicial",
  qgmx: "Detalhes da compra",
  fjtj: "Condições adicionais",
  guoji: "Nacionalidade",
  noJoin: "Participação não suportada",
  wancheng: "Preencher",
  pinggu:
    "《Formulário de avaliação de risco de investimento em moeda digital》",
  cyhd: "Atividades de participação",
};

const historyProject = {
  rushLimit: "Cota de compra",
  averagePic: "Preço médio",
  averageNum: "Número de compra",
};

const alipay = {
  alipaynum: "Quantidade de Compra",
  alipaynumNew: "Cota de Assistência",
  ShouldPay: "Pagável",
  VipDiscounts: "Desconto VIP",
  VipWin: "Ganhe Desconto de Sócio",
  willOpen: "Abertura em breve",
  actualPayment: "Pagamento Real",
  actualPaymentNew: "Assistência Atual",
  importPassword: "Por favor, digite a senha da transação",
  forGetPassword: "Esqueceu a senha da transação? ",
  promptlyAlipay: "Pague agora",
  purchaseSuccess: "Parabéns, o snap-up foi bem-sucedido",
  purchaseSuccessNew: "Parabéns, a assistência foi bem-sucedida",
  purchaseError:
    "Desculpe, o snap-up falhou, atualize a página e tente novamente",
};

const projectDetails = {
  text: "Certifique-se de que a posição exceda [*][**]",
  timelimitPic: "Preço por tempo limitado",
  subscriptionLimit: "Valor da compra",
  subscriptionLimitNew: "Valor da assistência",
  preheat: "Pré-aquecimento",
  supportAbort: "Prazo do seguro",
  unlockAbort: "Tempo de emissão",
  projectIntroduction: "Introdução do projeto",
  projectRole: "Regras da atividade",
  rule: "Regras de compra urgente",
  ruleNew: "Regras de assistência",
};

const purchaseOver = {
  haveSubscribed: "Cota já comprada",
  schedule: "Progresso atual",
  Stime: "Horário de início de compra urgente",
  StimeNew: "Horário de início da assistência",
  Etime: "Fim hora de compra urgente",
  EtimeNew: "Fim do tempo de assistência",
  successText:
    "O valor da arrecadação de fundos deste projeto [*] BAT, a arrecadação de fundos real atingiu a meta de arrecadação de fundos e a arrecadação de fundos foi bem-sucedida! ",
  success: "sucesso",
};

const myPurchase = {
  endUnlock: "desbloqueado no final da última rodada de compras de pânico",
  endUnlock2: "é emitido após o final da última rodada de compras de pânico",
  LText: "desbloqueado todos os dias durante o período de garantia",
  WText: "desbloqueado todos os dias fora do período de garantia",
  unlockend: "desbloqueado",
  record: "detalhes de compra",
  myPurchaseName: "projetos dos quais participei",
};

const mHeader = {
  sy: "Página inicial",
  ksjy: "Transação rápida",
  zyjy: "Transação profissional",
  c2c: "Transação C2C",
  otc: "OTC Transaction",
  zczx: "Asset Center",
  xwgg: "Anúncio de notícias",
  xwgg1: "Anúncio",
  lc: "BiKing Earn",
  gxlc: "High Interest Finance",
  dxjh: "FansUp!",
  fbjy: "Buy Coin",
  dl: "Login",
  zc: "Registro",
  jtzw: "Chinês simplificado",
  ftzw: "Chinês tradicional",
  english: "Inglês",
  kr: "한국어 ",
  qgms: "Comprar Seckill",
  xsjy: "Potencial Transação",
  zczgz: "Avaliação Total de Ativos",
  yhzx: "Central do Usuário",
  wdgl: "Gerenciamento de Pedidos",
  tc: "Conta de Saída",
  dltq: "Área de Baixa Circulação",
  sdgm: "Compra Flash",
  appdown: "Baixar APP",
  appdown1: "Baixar",
  biking: "Aplicativo BiKing",
  gfqb: "Carteira Oficial",
  xzbyapp: "Baixar BiKing APP",
  xzbyapp2: "Baixar BiKing APP",
  smewm: "Download QR Code",
  xzhyqb: "Baixar Carteira HyperPay",
  xzhyqb2: "Faça o download da Carteira HyperPay",
  bbjy: "Câmbio",
  hyjy: "Contrato Perpétuo",
  eftjy: "Transação ETF",
  byb: "Ganhe Moedas",
  newPos: "Pool de Mineração HBT",
  HyperPay: "Ganhar Moedas HyperPay",
  hqlc: "Mineração POS",
  newlc: "Ganhe Moedas",
  dd: "Pedidos",
  zichan: "Ativos",
  xxzx: "Central de Mensagens",
  zhyaq: "Conta e Segurança",
  sfyz: "Verificação de Identidade",
  wdvip: "Meu VIP",
  apigl: "Gerenciamento de API",
  hdzx: "Atividade Center",
  wdhb: "My Red Packet",
  flzx: "Welfare Center",
  bitloan: "Bi Dai Bao",
  ggjy: "Leverage Trading",
  hyxy: "Academy",
  flhd: "Welfare Activities",
  bitWin: "BiKing Bao",
};

const res = {
  seckill_project_000: "Exceção do sistema",
  seckill_project_001: "Nenhum item disponível",
  seckill_project_002: "Informações do item não existem",
  seckill_userInfo_001: "Usuário não existe",
  i18n_no_table_001: "Sistema está ocupado",
  seckill_record_1: "Falha no pagamento",
  seckill_7days_1: "No item atual, nenhuma regra de posição foi consultada",
  seckill_wallet_1: "Sistema está ocupado",
  seckill_wallet_2: "Saldo da carteira insuficiente",
  seckill_wallet_3: "Falha no pagamento",
  seckill_record_count_1: "Erro de dados",
  seckill_record_count_2: "Falha no pagamento",
  seckill_record_count_3: "Falha no pagamento",
  seckill_rounds_1: "Sistema está ocupado",
  seckill_rounds_2:
    "No item atual, nenhuma rodada de compra urgente foi encontrada",
  seckill_rounds_3: " Item atual In, a informação da rodada não foi encontrada",
  seckill_rounds_4: "O sistema está ocupado",
  seckill_rounds_5:
    "No projeto atual, a informação da rodada especificada não foi encontrada",
  seckill_pro_1: "Informações do item não foram encontradas",
  seckill_pro_2:
    "O valor da compra urgente é menor que a quantidade mínima de compra",
  seckill_pro_4: "O sistema está ocupado",
  seckill_pro_5: "O item não está na prateleira",
  seckill_pay_1: "O sistema está ocupado",
  seckill_pay_2: "O sistema está ocupado",
  seckill_pay_3: "Nenhuma informação do item foi consultada",
  seckill_pay_4:
    "O valor da compra urgente é menor que o valor mínimo da compra",
  seckill_pay_5:
    "O valor da compra urgente excede o valor restante desta rodada",
  seckill_pay_6: "Valor da compra sem pressa",
  seckill_pay_7: "Valor da compra é maior que o valor do snap-up",
  seckill_pay_8: "Sistema ocupado",
  seckill_pay_9: "Erro na senha da transação",
  seckill_pay_10: "Falha no pagamento, compre novamente",
  seckill_pay_11: "Falha no pagamento, compre novamente",
  seckill_pay_12: "Erro nas informações do usuário",
  seckill_pay_13: "Falha no pagamento",
  seckill_pay_14: "Erro na senha da transação",
  seckill_pay_15: "Sistema ocupado",
  seckill_pay_16: "Concluído",
  seckill_pay_17: "Desculpe, há muitas pessoas na fila, tente novamente",
  seckill_pay_18: "Esta rodada tem foi arrebatado",
  seckill_pay_19: "Esta rodada foi arrebatada",
  seckill_pay_20: "Por favor, primeiro faça login",
  seckill_pay_21: "Por favor, complete a autenticação de nome real primeiro",
  seckill_pay_22:
    "Este item está disponível apenas para usuários KYC na China continental",
  seckill_pay_23:
    "Este item está disponível apenas para usuários não KYC na China continental",
  seckill_pay_24:
    "O número de erros de senha de transação excede o limite, tente novamente mais tarde",
  seckill_hold_1:
    "A quantidade de [*] que você possui não atende aos requisitos de participação, participe novamente após a compra",
  seckill_survey_submited: "Você já enviou este questionário",
  seckill_survey_error: "Erro no processamento das informações do questionário",
  seckill_survey_info:
    "No item atual, as informações do questionário não são consultadas",
};

const purchase = {
  periods: "Fase [*]",
  timesSheaves: "Rodada [*]",
  supportPic: "[*] dias garantido preço, nunca quebra",
  earnings: "[*]% de renda, preço garantido",
  vipDiscount: "Desconto VIP, pegue e ganhe",
  limit: "Cota da rodada atual",
  timeLimit: "Preço por tempo limitado",
  schedule: "Progresso atual",
  finishHalf: "Concluído [*]%",
  subscriptionNum: "Quantidade da compra",
  vipText: "(VIP[*]) aproveite a compra ([**] [***] [****] desconto) desconto",
  supportType:
    " Segurado método do preço segurado: Durante o período de preço segurado, a BiKing colocará uma ordem de compra no mercado secundário ao preço segurado mais baixo. Os usuários podem escolher se querem vender dentro do período de preço segurado. Após o término do período de preço segurado, a ordem de compra de preço mínimo segurado relevante será cancelada. ",
  beAbouttoAlipay: "Apressando-se em breve",
  atOnceAlipay: "Apressando-se agora",
  atOnceAlipayNew: "Assista agora",
  atOnceAlipayed: "Você abocanhou, por favor, preste atenção na próxima rodada",
  atOnceAlipayedOver: "Você já abocanhou, não pode abocanhar novamente",
  atOnceAlipayedNew:
    "Você já auxiliou, por favor, preste atenção na próxima rodada",
  atOnceAlipayedNewOver: "Você já abocanhou, não pode participar novamente",
  website: "Website",
  whitePaper: "White paper",
  foreshow: "Aviso de Apressamento",
  startToUp: "Comece a abocanhar",
  startToUpNew: "Comece a ajudar",
  distanceStartToUp: "Dista nce para começar a pegar",
  num: "Atualmente acumulativo ([*]) pessoas Pegue ([**] BAT)",
  bannerText: "[*] Pegue [**] quantia",
  bannerTextNew: "[*] Ajude [**] quantia",
  nextProject: "Sua quantia foi arrebatada, preste atenção no próximo projeto",
  timesText:
    "Esta rodada está toda arrebatada, a próxima rodada [*]mês[**]dia [***]: [****]:[*****] comece na hora",
  times: "[*]dia [**] hora [***] minuto [****] segundo",
  viewDetail: "Ver detalhes",
  completePawd: "Concluir a configuração da senha da transação da conta",
  sureCoins:
    "Verificar se a posição é maior que [*] [**] (valor mínimo de compra)",
  sureBalance: "Verificar se o saldo de [*] na conta é maior que [**]",
  set: "Ir para configurações",
  available: "Cota disponível",
  holding: "Retenção de conta",
  startSoon: "A compra está prestes a começar",
  startSoonNew: "A assistência está prestes a começar",
  projectSupp: "Cota do projeto",
  projectSuppNew: " Assistência máxima",
  successBuy: "Compra bem-sucedida",
  successBuyNew: "Assistência bem-sucedida",
  projectLimit: "Restante antes do início do projeto",
  subscription: "Corrida bem-sucedida para comprar",
  subscriptionNew: "Assistência bem-sucedida",
  projectGoal: "Valor total da compra imediata deste item",
  projectGoalNew: "Valor da assistência deste projeto",
  goalFunds: "Compra urgente concluída atualmente",
  goalFundsNew: "Ajudando a atingir a meta",
};

const addContent = {
  hdjshy:'O evento acabou',
  qgsj: "Tempo de compra",
  qgsjNew: "Tempo de ajuda",
   gz: "Regras",
   zdjg: "Preço mais baixo",
   sq: "Recolher",
   qgms: "Compra rápida de morte instantânea",
   rgxm: "Participar de projetos",
   bled: "Cota atual",
   dqjd: "Progresso Atual",
   yjs: "Desbloqueado",
   yff: "emitido",
   qbcc: "Manter posição",
   cg: "exceder",
   jxmks: "De acordo com o início do projeto, ainda faltam",
   ycgrg: "Comprado com sucesso",
   cgrg: "Agarrado com sucesso",
   xmed: "Cota do Projeto",
   cxmck: "O valor da arrecadação de fundos deste projeto",
   ckmb: "A captação de recursos real atingiu a meta de captação de recursos",
   ck: "Angariação de fundos",
   ckxq: "Exibir detalhes",
   kqed: "Cota disponível para pegar",
   zhcc: "Posição da conta",
   jjks: "A compra de pânico está prestes a começar",
   mmsz: "Configuração de senha de transação de conta completa",
   qsz: "Ir para configurações",
   qbye: "Certifique-se de que o saldo de [*] na conta seja maior que [**]",
   zjcz: "Certifique-se de que a posição seja maior que [*] [**] (valor mínimo de compra)",
   jgdb: "Preço garantido, nunca quebra",
   jgyh: "Reembolso VIP, desconto no preço",
   bwbj: `​​Seguro padrão de moeda legal exclusivo`,
   bj: "[*] O preço é garantido por um dia, e o preço nunca será quebrado",
   sybj: "[*]% de receita, preço garantido",
   zk: "Desconto VIP, pegue e ganhe",
   r: "pessoa",
   lsxm: "Itens Históricos",
   // bpf: "Sem pausa por 15 dias, pode subir ou descer",
   bpf: "Com a ajuda da comunidade, a onda de benefícios maciços está chegando",
   // syybz: "O rendimento é garantido e a distribuição tem lucro",
   syybz: "O limite para participação é baixo e há benefícios para todos desfrutarem",
   // hg: "Retribuindo ao VIP, obtendo grandes descontos",
   hg: "Torne-se um membro VIP e aproveite mais vantagens",
   zgkx: "Até [*] [**] redução",
   vip_zgkx: "Quanto mais alto o nível VIP, mais descontos no preço total da compra. O VIP6 mais alto pode aproveitar [*][**] descontos",
   vip_zgkxNew: "Quanto maior o nível VIP, mais descontos no valor total da assistência. O VIP6 mais alto pode desfrutar de [*][**] descontos",
   blsysj: "Tempo restante na rodada",
   blqbqw: "Esta rodada acabou",
   xyl: "Próxima rodada",
   zskq: "Comece a pegar na hora certa",
   bljshs: "O fim desta rodada de compras de pânico acabou",
   zqyc: "Você só pode comprar uma vez em cada rodada, por favor, volte na próxima rodada!",
   zxkf: "Você não tem permissão para participar deste evento, entre em contato com o atendimento ao cliente para obter detalhes",
   zqycNew: "Você só pode ajudar uma vez em cada rodada, por favor, ajude novamente na próxima rodada!",
   wed: "Sua cota para este projeto é 0, preste atenção no próximo projeto",
   wedNew: "Seu valor de suporte para este projeto é 0, por favor, preste atenção no próximo projeto",
   zsqg: "Cota mínima de snap-up[*][**], adicione sua posição e snap-up",
   srmm: "Por favor, digite a senha da transação",
   smrz: "Por favor, complete a verificação de nome real KYC primeiro",
   qszjymm: "Defina a senha da transação primeiro",
   wenjuandiaocha: "Você precisa preencher a pesquisa antes de poder participar deste evento.",
   scqgms: "Carnaval dos Fãs do BiKing",
   // scqgms: "O primeiro modo de preço garantido",
   // hxyh: "Renda final garantida por tempo limitado, mais benefícios para VIPs",
   hxyh: "Ajude a comunidade BiKing e aproveite diversos benefícios",
   zsqged: "Valor mínimo de compra imediata[*] [**]",
   zsqgedNew: "Valor mínimo de assistência[*] [**]",
   wmtj: "A quantidade de [**] que você possui não atende às condições de participação, por favor, compre e participe novamente",
   qjchqg: "Por favor, aumente sua posição e corra para comprar",
   qjchqgNew: "Por favor, ajude depois de adicionar posições",
   rgjg: "Preço acelerado",
   qqg: "Ganhe um desconto",
   wdqgjl: "Meu Registro de Participação",
   ckxmxq: "Visualizar detalhes do projeto",
   t: "dia",
   ano: "[*]mês[**]dia",
   yrz: "A rodada [*] está esquentando",
   qgz: "A [*] rodada de compras de pânico",
   djlyjs: "A rodada [*] terminou",
   dj: "Nível VIP",
   xszk: "Taxa de desconto",
   jgzked: "Valor do desconto de participação",
   zked: "Valor do desconto",
   edw: "Cota extra será paga pelo preço normal",
   qbcczd: "Certifique-se de que a posição seja superior a 1000CWT (valor mínimo de compra)",
   qrrjcc: "juros diários médios de 7 dias",
   jlblks: "Desde o início desta rodada",
   jlbljs: "A partir do final da rodada",
   zgkqed: "A quantidade máxima que pode ser roubada",
   zgkzf: "Máximo a pagar",
   cggmsl: "A quantidade de compra que você preencheu excede o limite de quantidade de compra",
   bzzfzxgm: "A posição atual é insuficiente para pagar o valor mínimo da compra",
   bqzdqg: "O valor mínimo de compra é [*] [**]",
   zlzcLower:
     "O valor mínimo do suporte é [*], e o valor máximo é [**]. Após o término do evento, os tokens obtidos no suporte serão emitidos para sua conta em até 5 dias úteis.",
   zgqged: "O valor máximo é [*] [**]",
   yzbz: "Desconto exclusivo para fãs de moeda de alta qualidade por tempo limitado",
   xszkj: "Preço com desconto por tempo limitado",
   zlbxsq: "Ganhamento de tempo limitado da moeda corrente",
   wks: "não iniciado",
   jxz: "em andamento",
   qgsl: "Quantidade de compra",
   wcydxm: "Projetos que participei",
   bjq: "período de cotação",
   hgq: "Período de recompra",
   qzk: "Ganhe um desconto",
   qxzl: "Seja o primeiro a ajudar a ganhar fichas",
   ds: "Máxima assistência de potência",
   dhbl: "Relação de troca",
   jicj: "Preço básico",
   jiagzd: "O preço final será determinado dentro de 3 horas antes do início da venda urgente",
   zdyh: "Maior desconto",
};

const hyy = {
  bkt: "Não aberto",
  wqdkt: "Tenho certeza de ativar",
  kt12: "1. Antes de participar, você deve entender completamente o conhecimento básico e os riscos relacionados às transações de contrato de moeda digital e regras de negócios relacionadas à participação em bolsas de derivativos",
  kt13: "2. As questões de risco mencionadas acima neste lembrete de risco são apenas de natureza enumerativa e não podem listar todos os fatores de risco relacionados a transações de derivativos de ativos digitais em detalhes. Antes de os investidores participarem de transações e investimentos de derivativos de ativos digitais, eles também devem entender e dominar cuidadosamente outros possíveis fatores de risco.",
  kt14: "3. Esperamos sinceramente e sugerimos que os investidores, procedendo de suas próprias condições reais, como tolerância ao risco, decidam com prudência se desejam participar desta transação contratual e alocar racionalmente seus ativos digitais.",
  kt0: "Caro usuário:",
  kt1: "Você ainda não abriu uma conta de contrato e permissões de transação de contrato, leia atentamente o seguinte antes de decidir se deseja abrir:",
  kt2: "1. Quando você negocia no mercado de contratos, se a tendência do preço de mercado for desfavorável a você e sua margem de posição for insuficiente, o contrato perpétuo da BiKing executará a ordem de liquidação forçada em sua posição e divulgará os detalhes da liquidação forçada de acordo com o contrato do sistema.",
  kt3: "Em segundo lugar, você deve ler atentamente e cumprir as regras de negócios do contrato perpétuo BiKing, entender o mecanismo e os princípios operacionais do contrato e entender vários riscos no mercado.",
  kt4: "4. Os swaps perpétuos da BiKing estão conectados ao sistema de negociação de contrato. O lucro e a perda da posição do usuário mudam com a flutuação do mercado de contrato. Quando a perda é grande, a liquidação também ocorrerá no sistema de negociação de contrato. Solicita-se aos usuários que decidam seu próprio comportamento comercial de acordo com o mercado de contrato em tempo hábil e sejam responsáveis ​​por seus próprios lucros e perdas. Consequentemente, BiKing não assume qualquer responsabilidade de garantia presumida ou estabelecida.",
  kt5: "5. Em algumas condições extremas de mercado, pode ser difícil ou impossível para você fechar suas posições abertas. Por exemplo, quando seu lucro está em primeiro lugar na alavancagem efetiva PnL em todo o mercado de contratos e o fundo de seguro da contraparte não é suficiente para antecipar suas perdas de liquidação.",
  kt6: "6. A negociação de derivativos de ativos digitais pode enfrentar riscos regulatórios de política em certas jurisdições. Antes de negociar, você precisa fazer julgamentos prudentes com base na premissa de entender a política e o histórico regulatório da região comercial. Devido a mudanças nas leis, regulamentos e políticas em países e regiões relevantes, revisões nas regras de negociação para bolsas de contratos e introdução de medidas de emergência etc.",
  kt7: "Sétimo, devido a motivos fora do controle da parte da plataforma, como fatores de força maior, como terremotos, inundações, incêndios etc.",
  kt8: "Oito, transações de 'hedge', como transações especulativas, também enfrentam riscos causados ​​por flutuações de preços.",
  kta9: "9. Se você não executou autenticação de nome real ou não está vinculado ao Google para verificação, ou empresta sua conta para uma operação não pessoal, isso pode afetar a segurança do seu depósito contratual",
  kta10:
    "Terceiro, em algumas situações extremas de mercado, pode ser difícil ou impossível para você liquidar as posições abertas que você detém. Por exemplo, quando seu lucro está em primeiro lugar na alavancagem efetiva PnL em todo o mercado de contratos e o fundo de seguro da contraparte não é suficiente para antecipar suas perdas de liquidação.",
  kt9: "Eu li com atenção e estou disposto a correr o risco",
  kt10: "Abrir conta de contrato e autoridade de transação de contrato",
  zjhz: "Transferência de fundos",
  ljhz: "Transferir imediatamente",
  qx: "Cancelar transferência",
  khz: "Transferível",
  qxz: "Por favor escolha",
  bz: "Moeda",
  c: "De",
  zz: "Ir para",
  sl: "quantidade",
  qb: "Todos",
  ktcg: "Ativação bem-sucedida",
  ktsb: "Falha na ativação",
  hzcg: "Transferência bem-sucedida",
  hzsb: "Falha na transferência",
  wyyd: "", //desmarcado já leu a cópia do prompt
  tc: "Sair",
  warning1: "Por favor, selecione uma moeda",
  warning2: "A conta de transferência não pode estar vazia",
  warning3: "A conta de transferência não pode estar vazia",
  warning4: "Por favor, digite um número não maior que o número que pode ser transferido",
  gb: "Fechar",
  openSuccess: "Você abriu a transação do contrato",
  openSuccessTip: "Transfira fundos para a conta do contrato",
  warning5: "No máximo 4 casas decimais são reservadas",
  not_get_nm: "Desculpe, a atividade do código de lama terminou e esta transferência falhou ao obter o código de lama",
};
const trading = {
  gflj: "Link oficial",
  gw: "site oficial",
  qkllq: "Explorador de blocos",
  scfxsj: "Data da primeira emissão",
  fxzl: "Emissão total",
  ltzl: "circulação total",
  jy: "Transação",
  sj: "preço de mercado",
  tbxx: "Informações do gráfico",
  bzgk: "Visão Geral da Moeda",
  ddb: "Tabela de Pedidos",
  zxcj: "Último negócio",
  reload: "Atualizar",
	socketError: "Erro de rede, por favor",
	noData: "Sem dados",
	entrustorder: "Ordem",
	prices: "Preço",
	quantity: "Quantidade",
	grandtotal: "Cumulativo",
	transamount: "Valor de negociação",
	time: "Tempo",
	available: "Disponível",
	limitorder: "Preço limite",
	plancommission: "Ordem planejada",
	currentcommission: "Ordem",
	historycommission: "Ordem histórica",
	completecommission: "Ordem fechada",
	funds: "Fundo",
	hidetrading: "Ocultar outros pares de negociação",
	morecurrentcommission: "Ordens mais atuais",
	morehistorycommission: "Mais ordens históricas",
	moredocommission: "Mais ordens de negociação",
	realtimetrans: "Transação em tempo real",
	myassets: "Meus ativos",
	detail: "Detalhes",
	buyin: "Comprar",
	sellout: "Vender",
	login: "Login",
	transfer: "Transferir",
	recharge: "Recarga",
	withdrawal: "Comprar moeda",
	quickpurchase: "Moeda Fiat Quick Buy",
	default: "Padrão",
	ordertime: "Tempo de pedido pendente",
	tradingpair: "Par de negociação",
	direction: "Direção",
	types: "Tipo",
	commissionprice: "Preço do pedido",
	commissionnumber: "Quantidade do pedido",
	dealprice: "Preço médio da transação",
	dealnumber: "Quantidade da transação",
	triggerprice: "Preço de acionamento",
	cancelall: "Todos os cancelamentos",
	averageprice: "preço médio",
	totalsum: "total",
	fixedprice: "preço limite",
	marketprice: "preço de mercado",
	codeExpired: "código QR inválido",
	clickRefresh: "clique para atualizar",
	QRsuccessfully: "digitalizar código com sucesso",
	loginInApp: "confirme o login no APP",
	backtoQR: "retorne ao login do código QR",
	loginSuccess: "Você fez login com sucesso, bem-vindo ao ciclismo! ",
	loadingText: "Carregando...",
	searchPlaceholder: "Pesquisar",
  0: "tempo compartilhado",
	1: "1 minuto",
	5: "5 minutos",
	15: "15 minutos",
	30: "30 minutos",
	60: "1 hora",
	240: "4 horas",
	3600: "1 dia",
	10800: "1 semana",
	all: "todos",
	currency: "moeda",
	price: "preço mais recente",
	market: "lista de aumento",
	increase: "aumento",
	highestPrice: "maior",
	minimumPrice: "menor",
	turnover: "volume",
	jydlb: "lista de pares de negociação",
	bzjs: "introdução de moeda",
	currencyTransaction: "transação de moeda",
	leveragedTransaction: "negociação de alavancagem ",
	warning: "Aviso de risco: o fork do Bitcoin Cash tem grande incerteza, negociar ou investir em tokens futuros do fork tem grande risco,..., é muito provável que não sobreviva, e os tokens relevantes mantidos terão o risco de serem zerados. A BiKing não faz nenhuma promessa sobre o valor de quaisquer tokens de futuros bifurcados! ",
	zb: "Indicador",
	date: "Tempo",
	UpAnddown: "Alterar",
	amplitude: "Amplitude",
	dates: "Período:",
	password: "Senha de Negociação",
	errorPassword: "Por favor, digite a senha de negociação correta",
	worningPassword: "Por favor, digite a senha de negociação",
  cancel: "Cancelar",
	sure: "OK",
	canBuy: "Comprar",
	canCell: "Vender",
	withdraw: "Retirada",
	otc: "OTC, Entrada rápida e retirada de moeda Fiat",
	enterPrice: "Insira o preço",
	sellingPrice: "Preço de venda",
	purchasePrice: "Preço de compra",
	salesVolume: "Venda volume",
	buyingVolume: "Volume de compra",
	volume: "Valor da transação",
	serviceCharge: "Taxa de serviço",
	vip: "Desconto da taxa VIP de atualização",
	or: "ou",
	register: "Registro",
	totalPrice: "Valor da transação não pode ser maior que",
	amountTip: "Insira o valor correto",
	amountTipError: "quantidade não pode ser maior que",

  
	limitTrading: "transação limite",
	priceReminder: "lembrete de preço",
	SMSReminder: "lembrete sms",
	loginAccount: "conta de login",
	phone: "telefone celular",
	phoneNum: "digite o número do celular",
	phoneTips: "digite o número do celular correto",
	email: "email",
	emailNum: "digite o email",
  emailTips: "Por favor, digite o endereço de e-mail correto",
	aears: "Por favor, selecione o código de área",
	passwordError: "Por favor, digite a senha correta",
	passwordTips: "Por favor, digite a senha",
	forgetPassword: "Esqueceu a senha",
	noAccount: "Sem conta",
	goRegister: "Registre-se agora",
	appsys: "Verificação de APP para login seguro",
	xzapp: "Faça o download do APP mais recente",
	mmdl: "Senha de login",
	smdl: "Digite o código de login",
	google: "Google Authenticator",
	nybd: "Você está vinculado",
	zqyzm: "Por favor, digite o código de verificação correto",
	fsyzm: "Envie o código de verificação",
	flv: "Taxa",
	jz: "Valor líquido",
	jzdesc1: "Valor líquido longo=valor líquido no último ponto de ajuste*[1+3*(o último preço de transação do spot - o preço do último ponto de ajuste do estoque spot)/preço do último ponto de ajuste do estoque spot*100%];",
	jzdesc2: "Valor líquido curto=o valor líquido do último ponto de ajuste*[1-3*(o último preço de transação do estoque spot - o preço do último ponto de ajuste do estoque spot)/preço do último ponto de ajuste do estoque spot*100 %];",
	sbd: "três vezes mais",
	sbs: "três vezes menos",
	flvjs: `"A taxa de captação do ETF é a taxa de administração diária cobrada pela plataforma na proporção correspondente da alavancagem para pagar a taxa de captação gerada pela carteira do fundo. A taxa de administração será refletida no valor líquido...do ETF alavancado"
	e será cobrada apenas às 0: 00,
	horário de Cingapura.Se você não possuir o produto neste momento,
	nenhuma taxa será incorrida."`,
  mzsm: "Isenção de responsabilidade ",
  ido: "Li e concordo",
  exemption1: "Prezado cliente, olá!",
  exemption2:
     `"Obrigado por fazer login e usar os produtos ETF oficiais e serviços relacionados fornecidos pela plataforma BiKing (BiKing.ai) (doravante denominados "produtos ETF"). Por favor, leia a descrição do produto ETF e os seguintes avisos de risco cuidadosamente. descrição: "`,
     exemption3: `"《Perguntas frequentes sobre produtos ETF alavancados》"`,
     exemption4: "Aviso de risco:",
     exemption5:
     "1. O preço que você compra/vende não deve ter um grande desvio do valor líquido da unidade, caso contrário você sofrerá perdas correspondentes.",
     exemption6: "2. Se a direção for erroneamente avaliada, haverá o risco de o preço se aproximar de zero em condições extremas de mercado.",
     exemption7:
     `"A plataforma BiKing lembra solenemente que qualquer perda ou responsabilidade causada pelos riscos acima serão suportados por você, e a plataforma BiKing não será responsável por isso. Este aviso, juntamente com outros acordos, declarações, regras, etc. na plataforma BiKing, constitui o acordo integral entre a plataforma BiKing e você em relação aos serviços e produtos da plataforma BiKing."`,
   bzjs1: `"1. "3L" significa que o preço do par de negociação subjacente aumentou 1% e o valor líquido do produto aumentou 3%"`,
   bzjs2: `"2. "3S" significa que o preço do par de negociação subjacente cai 1% e o valor líquido do produto aumenta 3%`,
   bzjs3: `"3. O patrimônio líquido normal é ajustado às 0 horas todos os dias, e as condições extremas do mercado serão ajustadas durante o dia"`,
   bzjs4: `"4. A taxa de administração correspondente será cobrada diariamente para cada alavancagem"`,
   bzjs5:
     "5. Por favor, preste atenção para verificar o valor líquido antes de negociar. Sob condições extremas de mercado, o produto corre o risco de que o preço se aproxime de zero e o preço se desvie muito do valor líquido. Os investidores devem prestar atenção ao controle de riscos",
   gdjk: "Verifique o anúncio para mais detalhes",
   firstTrading: "Antes da primeira transação, defina a senha da transação",
   status: "Estado",
   status1: "a ser correspondido",
   status2: "Não vendido",
   status3: "Cancelamento do usuário",
   status4: "Transação parcial",
   status5: "Transação concluída",
   status6: "Inválido",
   allCancel: "Cancelar todos os pedidos em lotes",
   canceld: "Cancelar pedido",
   cancelsuccess: "Todos os pedidos foram cancelados com sucesso e [*] pedidos foram cancelados",
   VIP1: "Seu nível VIP",
   VIP2: "Taxas de transação mais baixas, melhor experiência de transação",
   VIP3: "Pegador:",
   VIP4: "Criador (pedido pendente):",
   buyAmount: "O valor da compra não pode ser maior que",
   sellAmount: "O valor da venda não pode ser maior que",
   buyAmountMin: "Seu saldo é insuficiente",
   sellAmountMin: "Seu saldo vendável é insuficiente",
}

const common = {
  wan: "dez mil",
  qian: "mil",
  yi: "bilhões",
}

const transferDialog = {
  	amountLowTipError: "A quantidade não pode ser menor que",
	划转: "transferência",
	资金互转: "transferência de fundos",
	币币账户: "conta de moeda",
	买币账户: "conta de compra de moeda",
	已冻结: "congelada",
	合约账户: "conta de contrato",
	未开通: "não aberta",
	杠杆账户: "conta de margem",
	币贷宝账户: "conta de bidibao",
	从: "de",
	转至: "transferência",
	币种: "moeda",
	数量: "quantidade",
	全部: "todos",
	用户未归还借贷的情况下: "Se o usuário não pagar o empréstimo, a taxa de risco é superior a 200% Os fundos podem ser transferidos ",
	可划转: "transferível",
	一阶: "1, primeiro nível",
	累计净划入: "transferência líquida acumulativa em",
	可获得: "obtido",
	泥码: "código de lama",
	二阶: "2, segundo nível",
	您尚未完成实名认证: "você não concluiu a autenticação de nome real",
	余额: "saldo",
	立即划转: "transferência imediata",
	资产划转: "transferência de ativos",
	用于维持现有仓位的保证金: "margem para manter posições existentes",
	归还数量: "valor de devolução",
	您的币贷宝账户尚未开通: "sua conta Bidaibao não foi aberta, abra primeiro",
	请输入正确的数量: "insira o valor correto",
	划转金额不能为: "O valor da transferência não pode ser 0",
	账户可用余额不足: " Saldo insuficiente disponível na conta",
	划转失败: "Falha na transferência",
	划转成功: "Transferência bem-sucedida",
	本次划转未能获得泥码: "Desculpe, a atividade do código de lama terminou e esta transferência falhou ao obter o código de lama",
	您只需再向合约账户划转: "Você só precisa transferir [*]USDT para a conta do contrato para obter o código de lama [**] USDT",
	您向合约账户: "Sua transferência líquida acumulativa para a conta do contrato<br/>mais de [*]USDT, obtenha",
	请输入划转数量: "Insira o valor da transferência",
}

export {
  state,
  subheader,
  purchase,
  purchaseCondition,
  historyProject,
  alipay,
  projectDetails,
  purchaseOver,
  myPurchase,
  mHeader,
  res,
  addContent,
  hyy,
  trading,
  common,
  transferDialog,
}



// WEBPACK FOOTER //
// ./src/i18n/lang/pt_BR.js